import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentChangeAction, Query } from '@angular/fire/firestore';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../auth.service';
import { Observable, combineLatest } from 'rxjs';
import firebase from 'firebase/app';
@Component({
  selector: 'app-ventas-fijas',
  templateUrl: './ventas-fijas.component.html',
  styleUrls: ['./ventas-fijas.component.scss']
})
export class VentasFijasComponent implements OnInit {  

  private ventasCol: AngularFirestoreCollection<any>;
  public  ventas:    any[];
  public  vendedoresMap: Map<String,any> = new Map<String,any>();
  public  vendedores:any[] = [];

  public displayedColumns = [
    "cedula", "nombre", 
    "ciudad", "barrio", "estrato", "direccion",
    "reporta", "fechaReporta", "servicios", "estado",    
    "telefono", "email",    
    "options"
  ];

  @ViewChild(MatDatepicker, {static: false}) pFecha: MatDatepicker<Date>;
  public fechaExpedicion:Date;

  public  allItems: any[];  

  //public  dataSource = new MatTableDataSource<any>();  

  public vendedor:string = "";

  public estado:string = "CREADA";

  public venta;

  public user:firebase.User;

  constructor(
    private afFirestore: AngularFirestore, 
    private snackBar: MatSnackBar,
    public authService: AuthService){ 
      this.venta = null;
  }

  ngOnInit() {
    this.ventasCol = this.afFirestore.collection<any>(
      "ventas-fijas",
      ref => ref
        .where("estado", "==", this.estado)    
        .orderBy("fechaReporta", "desc")
    );
  }

  private suscription = null;

  public isLoading:boolean = false;  

  ngAfterViewInit(){    
    if( this.suscription != null ){
      this.suscription.unsubscribe();
    }       
    this.suscription = this.ventasCol
      .snapshotChanges().subscribe(
      (newVentas)=>{        
        this.isLoading = true;
        this.ventas = newVentas.map(
          (newVenta)=>{
            const newVenta2 = {id: newVenta.payload.doc.id,...newVenta.payload.doc.data()};                        
            this.vendedoresMap.set(
              newVenta2["reporta"], 
              {
                "cedula": newVenta2["reporta"],
                "nombre": newVenta2["nombre-reporta"] !== undefined ? newVenta2["nombre-reporta"] : newVenta2["reporta"],
                "tipo": newVenta2["tipo-reporta"]
              }
            );
            return newVenta2;
          }
        );
        this.isLoading = false;
        this.vendedoresMap.forEach(
          (v,k)=>{
            this.vendedores.push(v);
          }
        );        
      }
    );   
    this.authService.afAuth.user.subscribe(
      (newUser)=>{
        this.user = newUser;
      }
    );    
  }  

  trackByUid(index, item) {
    return item.id;
  }

  applyFilter() {      
    this.isLoading = true;    
    this.ventasCol = this.afFirestore.collection<any>(
      "ventas-fijas", 
      ref => {
        let ref2:Query = ref;
        let filter = false;
        if(this.vendedor && this.vendedor.length > 0){
          ref2 = ref2.where("vendedor", "==", this.vendedor);
          console.log("Vendedor "+this.vendedor)          
        }                
        if(this.estado && this.estado.length > 0){
          ref2 = ref2.where("estado", "==", this.estado);
          console.log("Estado  "+this.estado)          
        }                     
        return ref2.orderBy("fechaReporta", "desc");
      }
    );      
    this.ngAfterViewInit();
  }  

  showUpdate(venta){
    this.venta = {...venta};
    this.venta.servicios.forEach(
      (servicio)=>{
        console.log("servicios "+servicio);
        switch(servicio){
          case "TV":
            this.tv = true;
            break; 
          case "Internet":
            this.internet = true;
            break; 
            case "Fijo":
              this.fijo = true;
              break; 
        }
      }
    );
    this.fechaExpedicion = new Date(this.venta["fechaExpedicion"].toMillis());
  }

  public tv:boolean;
  public internet:boolean;
  public fijo:boolean;

  showList(){
    this.venta = null;
  }

  update(){
    var ventaRef = this.afFirestore.collection<any>("ventas-fijas").doc(this.venta.id).ref;   
    this.venta.fechaExpedicion = this.fechaExpedicion;
    var servicios: string[] = [];
    if( this.tv ){
      servicios.push("TV");
    }
    if( this.internet ){
      servicios.push("Internet");
    }
    if( this.fijo ){
      servicios.push("Fijo");
    }
    this.venta.servicios = servicios;   
    this.venta["fechaExpedicion"] = this.fechaExpedicion;

    ventaRef.set(
        {
          "resuelve": this.user.uid,
          "nombre-resuelve": this.user.displayName,
          "fechaResuelve": new Date(),
          ...this.venta
        }, 
        {merge: true}
      )
      .then(
        ()=>{
          this.showList();
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado actualizando la venta","Entiendo",{duration: 2000});
        }
      ); 
  }
}
